/**
 * Module dependencies.
 */

import { ChangeEvent, forwardRef } from 'react';
import { FormFieldProps } from 'src/types/form';
import { InputDate, InputDateProps } from './index';
import { assignRefs } from 'src/core/utils/refs';
import { useController } from 'react-hook-form';

/**
 * Export `InputFieldProps` interface.
 */

export type InputFieldProps = Omit<InputDateProps, 'hasError' | 'id'> &
  FormFieldProps<HTMLInputElement, InputDateProps['value']>;

/**
 * Export `InputDateField` component.
 */

export const InputDateField = forwardRef((props: InputFieldProps, forwardedRef: any) => {
  const { control, defaultValue = '', name, onChangeNormalizer, rules, ...rest } = props;

  const {
    field: { onBlur, onChange, ref, value },
    fieldState: { error }
  } = useController({
    control,
    defaultValue,
    name,
    rules
  });

  return (
    <InputDate
      {...rest}
      error={error?.message}
      hasError={!!error}
      id={name}
      onBlur={onBlur}
      onChange={
        !onChangeNormalizer
          ? onChange
          : event => onChangeNormalizer(event as ChangeEvent<HTMLInputElement>, onChange, value)
      }
      ref={assignRefs(forwardedRef, ref)}
      value={value}
    />
  );
});

/**
 * `InputDateField` display name.
 */

InputDateField.displayName = 'InputDateField';
